<template>
  <div class="modal-goodslist">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">套餐添加</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <div>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="名称" required prop="name">
                  <el-input v-model="addForm.name" placeholder="请输入套餐名称"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="护理等级" required prop="nursingLevelCode">
                  <el-select v-model="addForm.nursingLevelCode" @change="nursingChange" placeholder="请选择护理等级" style="width:100%">
                    <el-option
                        v-for="item in nursingLevelList"
                        :key="item.nursingLevelCode"
                        :label="item.name"
                        :value="item.nursingLevelCode">
                      <span style="float: left">{{ item.name }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.priceMonth}}元/月</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="房间类型" required prop="roomTypeCode">
                  <el-select v-model="addForm.roomTypeCode" @change="roomTypeChange" placeholder="请选择房间类型" style="width:100%">
                    <el-option
                        v-for="item in roomTypeList"
                        :key="item.roomTypeCode"
                        :label="item.name"
                        :value="item.roomTypeCode">
                      <span style="float: left">{{ item.name }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.priceMonth}}元/月</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
<!--              <el-col :span="24" class="item">-->
<!--                <div style="margin-bottom:10px;">机构参数</div>-->
<!--                <div v-if="institutionArgList.length==0" style="color:red">未设置机构参数</div>-->
<!--                <div style="color:red;" v-for="item in institutionArgList" :key="item.institutionFeeCode">-->
<!--                                    <span>-->
<!--                                        {{item.name}}：{{item.price}} 元/天-->
<!--                                    </span>-->

<!--                </div>-->
<!--              </el-col>-->
            </el-row>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="建议价格(元/月)">
                  <el-input type="number" ref="univalence" v-model="advisePrice" :disabled="true"  placeholder="建议单价"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="实际价格(元/月)" required prop="univalence">
                  <el-input type="number" ref="univalence" v-model="addForm.univalence" :disabled="disabledPrice" placeholder="请输入单价"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Add',
  data() {
    return {

      loading: false,
      disabledPrice:false,
      nursingLevelPrice:0,
      roomTypePrice:0,
      feeSumPrice:0,
      nursingLevelList:[],
      roomTypeList:[],
      institutionArgList:[],
      advisePrice:"",
      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        name:'',
        univalence:'',
        nursingLevelCode:'',
        roomTypeCode:'',
      },
      rules:{
        name:[
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        univalence:[
          { required: true, message: '请输入单价', trigger: 'blur' },
        ],
        nursingLevelCode:[
          { required: true, message: '请选择护理等级', trigger: 'blur' },
        ],
        roomTypeCode:[
          { required: true, message: '请选择房间类型', trigger: 'blur' },
        ],
      }


    }
  },

  methods: {
    init(){
      this.$refs.addForm.resetFields();
      this.getNursingList();
      this.getRoomTypeList();
      //this.getFeeList();

    },
    closeSelf() {
      this.$emit("closeAdd");
    },
    getNursingList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"NursingLevel/List",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              if(response.data.data.length==0){
                this.disabledPrice = true;
              }
              this.nursingLevelList=response.data.data

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },
    getRoomTypeList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"RoomType/List",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode()

        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              if(response.data.data.length==0){
                this.disabledPrice = true;
              }
              this.roomTypeList=response.data.data

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },

    nursingChange(){
      this.nursingLevelList.forEach(element => {
        if(this.addForm.nursingLevelCode==element.nursingLevelCode){
          this.nursingLevelPrice = element.priceMonth;
        }
      });
      if(this.addForm.roomTypeCode!=""){
        this.advisePrice = 0;
        this.advisePrice=this.nursingLevelPrice+this.roomTypePrice+this.feeSumPrice;
      }
    },

    roomTypeChange(){
      this.roomTypeList.forEach(element => {
        if(this.addForm.roomTypeCode==element.roomTypeCode){
          this.roomTypePrice = element.priceMonth;

        }
      });
      if(this.addForm.nursingLevelCode!=""){
        this.advisePrice = 0;
        this.advisePrice=this.nursingLevelPrice+this.roomTypePrice+this.feeSumPrice;
      }
    },

    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){
      this.loading = true;
      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckinSetmeal/Add",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


  }
}


</script>





<style lang="scss" scoped>

.modal-goodslist {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-x:auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 600px;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }
    .modal-body {
      position: relative;
      padding: 20px 0px;
      z-index: 99;
      height: 100%;
    }
    .modal-footer {
      border-top: 1px solid #eee;
      justify-content: flex-end;
      padding: 15px;
      display: flex;
    }


  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left:16px;
  width:56px;
  height: 36px;
  border:none;
  cursor: pointer;
}
.btn-close {
  color: #313131;
  background-color:transparent;
}



.row{
  padding: 10px 0px;
}
.item{
  padding: 0px 20px;
}
.label{
  padding: 5px 0px;
}


</style>
